import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEnvironmentById } from '../../api/documentAPI';
import { deleteFiles } from '../../api/documentAPI';
import { useAtom } from 'jotai';
import { allowDeleteAtom } from '../../atoms/useAllowDeleteAtom';

const DocumentsList = ({ id }) => {
    const [t, ] = useTranslation('global');
    const [msg, setMsg] = useState('');
    const [documents, setDocuments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [allowDelete, setAllowDelete] = useAtom(allowDeleteAtom);

    const fetchData = () => {
      getEnvironmentById(id)
      .then((data) => {
        setDocuments(data);
      });  
    }    

    useEffect(() => {
      if(id) {
        fetchData();
      }
      setMsg('');
      }, [id]); 

    useEffect(() => {
      const intervalId = setInterval(() => {
          fetchData();
      }, 5000);
      // Cleanup function to clear the interval and prevent potential memory leaks
      return () => {
          clearInterval(intervalId);
      };
    }, [id, documents]);

    const handleDelete = (id) => {
      setIsLoading(true);
      deleteFiles(id);
      setIsLoading(false);
      setMsg(t('filesDeleted'));
      fetchData();
    }

  return (
    <div className="document-list">
        <h3>{t('documents')}</h3>
        {msg && 
          <div className='success-msg'> 
              { msg }  
          </div>
        }       
        {documents.map((doc, key) => (
            <div key={key} className='doc-detail'>
                <span className='doc-name'>{doc.FileName}</span>             
                <div className='doc-status-wrap'>
                  <span className={'doc-status status-' + doc.Status}>{t('status_'+ doc.Status)}</span>     
                  {allowDelete ? 
                      <span className="material-symbols-outlined del-icon" onClick={()=> handleDelete(doc.Id)}>close</span>
                  : null}       
                </div>
            </div>
        ))}
    </div>
  );
}

export default DocumentsList;